export {default as RunTests} from "./RunTests";
export {default as Search} from "./Search";
export {default as Sections} from "./Sections";
export {default as Variables} from "./Variables";
export {default as History} from "./History";
export {default as InitializeAction} from "./InitializeAction";

export const DRAWER_IDS = {
  SEARCH: "search",
  SECTIONS: "sections",
  VARIABLES: "variables",
  HISTORY: "history",
  RUN_TESTS: "run-tests",
  INITIALIZE_ACTION: "initialize-action",
};
